import { Tab } from "@/components/elements/Tab";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const SYSTEM_SETTINGS_TABS = [
  { label: "いろはな管理者", value: AppRoutes.systemSettingsAdminUsers, enable: true },
  { label: "通知設定", value: AppRoutes.systemSettingsNotification, enable: true },
  { label: "メンテナンスツール", value: AppRoutes.systemSettingsMaintenance, enable: true },
];

const SystemSettingLayout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const activeTab = SYSTEM_SETTINGS_TABS.find((tab) => pathname.startsWith(tab.value))?.value ?? SYSTEM_SETTINGS_TABS[0].value;

  const handleTabChange = (_: React.SyntheticEvent, value: string | number) => {
    const currentTab = SYSTEM_SETTINGS_TABS.find((tab) => tab.value === value);
    if (!currentTab?.enable) return;
    navigate(value as string);
  };

  return (
    <Stack gap={3}>
      <Typography variant="head20Bold" color={text.primary}>
        システム設定
      </Typography>

      <Tab value={activeTab} selected={activeTab} options={SYSTEM_SETTINGS_TABS} onChange={handleTabChange}>
        <Outlet />
      </Tab>
    </Stack>
  );
};

export default SystemSettingLayout;
